import React, { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';

export default ({ optionsProp = [], selectedNewOptionHandler }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState(optionsProp);
    const [value, setValue] = useState(null);

    const createOption = (label) => ({
        label,
        value: label.toLowerCase().replace(/\W/g, ''),
    });

    const handleCreate = (inputValue) => {
        setIsLoading(true);
        setTimeout(() => {
            const newOption = createOption(inputValue);
            setIsLoading(false);
            setOptions((prev) => [...prev, newOption]);
            setValue(newOption);
            selectedNewOptionHandler(newOption);
        }, 500);
    };


    useEffect(() => {
        setOptions(optionsProp);
    }, [optionsProp])
    return (
        <CreatableSelect
            isClearable
            isDisabled={isLoading}
            isLoading={isLoading}
            onChange={(newValue) => { setValue(newValue); selectedNewOptionHandler(newValue) }}
            onCreateOption={handleCreate}
            options={options}
            value={value}
            noOptionsMessage={() => "No options, please write something to create one"}
            placeholder="Select an option or type to create a new one..."
        />
    );
};